import constants from './constants.json';

export const completedStatuses = [
    constants.jobStatus.completed,
    constants.jobStatus.verification,
    constants.jobStatus.rejected,
];

export const chattableStatuses = [
    constants.jobStatus.assigned,
    constants.jobStatus.started,
    constants.jobStatus.reported,
    constants.jobStatus.completed,
    constants.jobStatus.accepted,
    constants.jobStatus.rejected,

];

export const endChatStatuses = [
    constants.jobStatus.accepted,
    constants.jobStatus.rejected,
];

export const editableStatuses = [
    constants.jobStatus.open,
    constants.jobStatus.assigned
];

